module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Weddings .fa63e313.jpg";